module.exports = __webpack_public_path__ + "static/media/4ODA9.31e38c97.jpg";